/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum PersonnelSubarea {
    MarineBusiness1 = 'Marine Business (1)',
    BusinessSupport5 = 'Business Support (5)',
    EnergyBusiness6 = 'Energy Business (6)',
    MarineVoyageBusiness3 = 'Marine Voyage Business (3)',
    MarineSystemsBusiness2 = 'Marine Systems Business (2)',
    PortfolioBusiness4 = 'Portfolio Business (4)',
    WrtsilCorporation8 = 'Wärtsilä Corporation (8)',
    EnergyStorageBusiness9 = 'Energy Storage Business (9)'
}

export function PersonnelSubareaFromJSON(json: any): PersonnelSubarea {
    return PersonnelSubareaFromJSONTyped(json, false);
}

export function PersonnelSubareaFromJSONTyped(json: any, _: boolean): PersonnelSubarea {
    return json as PersonnelSubarea;
}

export function PersonnelSubareaToJSON(value?: PersonnelSubarea | null): any {
    return value as any;
}
